import { render } from "./app-button-border-left.vue?vue&type=template&id=4b155bf7"
import script from "./app-button-border-left.vue?vue&type=script&lang=js"
export * from "./app-button-border-left.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/button/app-button-border-left.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b155bf7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b155bf7', __exports__)) {
    console.log('reload')
    api.reload('4b155bf7', __exports__)
  }
  
  module.hot.accept("./app-button-border-left.vue?vue&type=template&id=4b155bf7", () => {
    console.log('re-render')
    api.rerender('4b155bf7', render)
  })

}


export default __exports__